/* istanbul ignore file */
import { SidebarStickyMenu, SidebarMenuItem } from 'framework/ui/menu';
import { useProcessInstanceId, useProcessInstanceUrl } from 'domain/gpo/cockpit/instance/processInstanceRoute';
import React from 'react';
import { useAuthorization } from 'framework/authorization';
import { MODIFY_INSTANCE_TOKEN_POSITIONS } from 'domain/gpo/cockpit/instance/Show/token/processInstanceTokenService';
import { RESOLVE_PROCESS_INCIDENT } from 'domain/gpo/cockpit/instance/Show/incident/processIncidentService';
import HealingIcon from '@mui/icons-material/Healing';

const ProcessInstanceMenu = () => {
  const { isGranted } = useAuthorization();
  const isTokenModificationsAvailable = isGranted(MODIFY_INSTANCE_TOKEN_POSITIONS);
  const isProcessIncidentsAvailable = isGranted(RESOLVE_PROCESS_INCIDENT);

  const id = useProcessInstanceId();
  const {
    getHistoryUrl,
    getIssuesUrl,
    getVariablesUrl,
    getSubprocessesUrl,
    getSupportIssuesUrl,
    getTokenModificationsUrl,
    getIncidentsUrl,
    getTracingUrl,
  } = useProcessInstanceUrl();

  return (
    <SidebarStickyMenu>
      <SidebarMenuItem linkUrl={`${getHistoryUrl(id)}`} name="History" icon="history" />
      <SidebarMenuItem linkUrl={`${getIssuesUrl(id)}`} name="Issues" icon="user-o" />
      <SidebarMenuItem linkUrl={`${getVariablesUrl(id)}`} name="Variables" icon="bars" />
      <SidebarMenuItem linkUrl={`${getSubprocessesUrl(id)}`} name="Subprocesses" icon="code-fork" />
      <SidebarMenuItem linkUrl={`${getTracingUrl(id)}`} name="Tracing" icon="share-alt" />
      <SidebarMenuItem linkUrl={`${getSupportIssuesUrl(id)}`} name="Support Requests" icon="ambulance" />
      {isTokenModificationsAvailable && (
        <SidebarMenuItem linkUrl={`${getTokenModificationsUrl(id)}`} name="Token Modifications" icon="circle" />
      )}
      {isProcessIncidentsAvailable && (
        <SidebarMenuItem linkUrl={`${getIncidentsUrl(id)}`} name="Active Incidents" icon={<HealingIcon />} />
      )}
    </SidebarStickyMenu>
  );
};

export default ProcessInstanceMenu;
